export default "<payment-partners\n  model=\"vm.model.depositsBlacklist\"\n  form=\"vm.form\">\n</payment-partners>\n";